import AirportPaginatedDropdown from "components/dropdowns/paginated/AirportPaginatedDropdown";
import { useValidateIsNotNull } from "formvalidation/hooks";
import React from "react";

interface Props {
  value: server.dto.Airport
  validatorKey: string
  focusOnMount?: boolean
  isClearable?: boolean
  onChange: (airport: server.dto.Airport) => void
}

export const AirportDropdownInput = (props: Props) => {
  const validation = useValidateIsNotNull({
    key: props.validatorKey,
    title: RESX.Flight.Airport,
    value: props.value,
  });

  return <AirportPaginatedDropdown
    value={props.value}
    onChange={(airport: server.dto.Airport) => {
      props.onChange(airport);
    }}
    config={{
      isSearchable: true,
      isClearable: props.isClearable ?? false,
      hasError: validation.error.hasError,
      focusOnMount: props.focusOnMount,
    }}
  />;
}